
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "OAA_S",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/OAA_S.vue